import type { SVGProps } from 'react';

const SvgDarkLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M16.7794 14.562C12.3402 14.562 8.74143 10.8934 8.74143 6.36807C8.74143 5.4253 8.90073 4.52159 9.19002 3.67971C9.33176 3.26727 8.94086 2.86912 8.55002 3.04104C5.28615 4.47671 3 7.78151 3 11.6356C3 16.8074 7.11288 21 12.1863 21C16.3436 21 19.8473 18.182 20.9787 14.3192C21.1005 13.9033 20.6767 13.5469 20.2967 13.736C19.2344 14.2646 18.0412 14.562 16.7794 14.562Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgDarkLt;
